import {
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Switch,
} from '@material-ui/core';

import { useFilterShortcut } from '@spotify/confidence-core-react';

export function FilterShortcutToggle() {
  const [enabled, setEnabled] = useFilterShortcut();

  return (
    <ListItem ContainerComponent="div">
      <ListItemText
        primary="Filter shortcut"
        secondary="Use Cmd+F to focus the filter input"
        style={{ marginRight: '12px' }}
      />
      <ListItemSecondaryAction style={{ right: 0 }}>
        <Switch
          checked={enabled}
          onChange={() => setEnabled(!enabled)}
          name="filterShortcut"
        />
      </ListItemSecondaryAction>
    </ListItem>
  );
}
